import { Icon } from '@chakra-ui/react';

export const NetchexClose = (props) => (
  <Icon viewBox="0 0 18 18" boxSize="16px" color="icon.g1" {...props}>
    <g clipPath="url(#clip0_2197_2320723)">
      <path
        d="M15.9131 0.482422C16.3289 0.0669081 16.9847 0.0409229 17.4307 0.404297L17.5176 0.482422C17.9334 0.898366 17.9596 1.55678 17.5957 2.00293L17.5176 2.08887L10.7148 8.8584L10.6084 8.96387L10.7139 9.07031L17.5166 15.9131H17.5176C17.9333 16.3289 17.9593 16.9848 17.5957 17.4307L17.5176 17.5176C17.1015 17.9336 16.445 17.9591 15.999 17.5947L15.9131 17.5176V17.5166L9.07031 10.7139L8.96387 10.6084L8.8584 10.7148L2.08887 17.5176C1.67291 17.9332 1.01537 17.9585 0.569336 17.5947L0.482422 17.5176C0.0666008 17.1016 0.0404557 16.445 0.404297 15.999L0.482422 15.9131H0.483398L7.28711 9.07031L7.39258 8.96387L7.28613 8.85742L0.482422 2.08887C0.0667335 1.6729 0.0404722 1.01452 0.404297 0.568359L0.482422 0.482422C0.898289 0.0668206 1.5567 0.0406517 2.00293 0.404297L2.08887 0.482422L8.8584 7.28613L8.96387 7.39258L9.07031 7.28613L15.9131 0.482422Z"
        fill="#333333"
        stroke="white"
        strokeWidth="0.3"
      />
    </g>
    <defs>
      <clipPath id="clip0_2197_2320723">
        <rect width="18" height="18" fill="white" />
      </clipPath>
    </defs>
  </Icon>
);
